import Vue from 'vue'
import Router from 'vue-router'
import { normalizeURL, decode } from 'ufo'
import { interopDefault } from './utils'
import scrollBehavior from './router.scrollBehavior.js'

const _36f17688 = () => interopDefault(import('..\\pages\\about\\index.vue' /* webpackChunkName: "pages/about/index" */))
const _7bca490d = () => interopDefault(import('..\\pages\\career\\index.vue' /* webpackChunkName: "pages/career/index" */))
const _55a5b04e = () => interopDefault(import('..\\pages\\contact.vue' /* webpackChunkName: "pages/contact" */))
const _52a1920b = () => interopDefault(import('..\\pages\\gallery.vue' /* webpackChunkName: "pages/gallery" */))
const _7fa46c1e = () => interopDefault(import('..\\pages\\global-presence.vue' /* webpackChunkName: "pages/global-presence" */))
const _33e4abdf = () => interopDefault(import('..\\pages\\local-information\\index.vue' /* webpackChunkName: "pages/local-information/index" */))
const _89a0932c = () => interopDefault(import('..\\pages\\news.vue' /* webpackChunkName: "pages/news" */))
const _ca9c0c24 = () => interopDefault(import('..\\pages\\privacy-policy.vue' /* webpackChunkName: "pages/privacy-policy" */))
const _7409d6da = () => interopDefault(import('..\\pages\\solutions.vue' /* webpackChunkName: "pages/solutions" */))
const _773a5762 = () => interopDefault(import('..\\pages\\tempvideo\\index.vue' /* webpackChunkName: "pages/tempvideo/index" */))
const _16a260ce = () => interopDefault(import('..\\pages\\tracking.vue' /* webpackChunkName: "pages/tracking" */))
const _d397387c = () => interopDefault(import('..\\pages\\about\\certificates.vue' /* webpackChunkName: "pages/about/certificates" */))
const _38b5fa04 = () => interopDefault(import('..\\pages\\about\\history.vue' /* webpackChunkName: "pages/about/history" */))
const _08a03c98 = () => interopDefault(import('..\\pages\\about\\numbers.vue' /* webpackChunkName: "pages/about/numbers" */))
const _e2f5fa1e = () => interopDefault(import('..\\pages\\about\\terms.vue' /* webpackChunkName: "pages/about/terms" */))
const _444489d7 = () => interopDefault(import('..\\pages\\career\\application\\index.vue' /* webpackChunkName: "pages/career/application/index" */))
const _542d34f7 = () => interopDefault(import('..\\pages\\career\\programletnjeprakse\\index.vue' /* webpackChunkName: "pages/career/programletnjeprakse/index" */))
const _12c95257 = () => interopDefault(import('..\\pages\\solution\\automotive-logistics\\index.vue' /* webpackChunkName: "pages/solution/automotive-logistics/index" */))
const _59c0465a = () => interopDefault(import('..\\pages\\solution\\contract-logistics\\index.vue' /* webpackChunkName: "pages/solution/contract-logistics/index" */))
const _54919e96 = () => interopDefault(import('..\\pages\\career\\programletnjeprakse\\galerija\\index.vue' /* webpackChunkName: "pages/career/programletnjeprakse/galerija/index" */))
const _7b7c48c0 = () => interopDefault(import('..\\pages\\career\\programletnjeprakse\\iskustvakolega\\index.vue' /* webpackChunkName: "pages/career/programletnjeprakse/iskustvakolega/index" */))
const _2e723cde = () => interopDefault(import('..\\pages\\career\\programletnjeprakse\\praksainformacije\\index.vue' /* webpackChunkName: "pages/career/programletnjeprakse/praksainformacije/index" */))
const _6a5257e6 = () => interopDefault(import('..\\pages\\career\\programletnjeprakse\\stipendiranjestudenata\\index.vue' /* webpackChunkName: "pages/career/programletnjeprakse/stipendiranjestudenata/index" */))
const _111d40c9 = () => interopDefault(import('..\\pages\\career\\programletnjeprakse\\usloviucesca\\index.vue' /* webpackChunkName: "pages/career/programletnjeprakse/usloviucesca/index" */))
const _212c50a2 = () => interopDefault(import('..\\pages\\career\\programletnjeprakse\\viseoprogramu\\index.vue' /* webpackChunkName: "pages/career/programletnjeprakse/viseoprogramu/index" */))
const _3179d849 = () => interopDefault(import('..\\pages\\local-information\\albania\\m-one-i.vue' /* webpackChunkName: "pages/local-information/albania/m-one-i" */))
const _0d1c21da = () => interopDefault(import('..\\pages\\local-information\\bosnia\\m-one.vue' /* webpackChunkName: "pages/local-information/bosnia/m-one" */))
const _6226742f = () => interopDefault(import('..\\pages\\local-information\\bosnia\\m-one-i.vue' /* webpackChunkName: "pages/local-information/bosnia/m-one-i" */))
const _2748a131 = () => interopDefault(import('..\\pages\\local-information\\bosnia\\warehouse-lukavica-sarajevo\\index.vue' /* webpackChunkName: "pages/local-information/bosnia/warehouse-lukavica-sarajevo/index" */))
const _585fa4b5 = () => interopDefault(import('..\\pages\\local-information\\croatia\\warehouse-bobovica\\index.vue' /* webpackChunkName: "pages/local-information/croatia/warehouse-bobovica/index" */))
const _1089e440 = () => interopDefault(import('..\\pages\\local-information\\macedonia\\m-one-i.vue' /* webpackChunkName: "pages/local-information/macedonia/m-one-i" */))
const _6e7b2282 = () => interopDefault(import('..\\pages\\local-information\\montenegro\\m-one-i.vue' /* webpackChunkName: "pages/local-information/montenegro/m-one-i" */))
const _2d1301ab = () => interopDefault(import('..\\pages\\local-information\\slovenia\\logatec-warehouse\\index.vue' /* webpackChunkName: "pages/local-information/slovenia/logatec-warehouse/index" */))
const _019d72a8 = () => interopDefault(import('..\\pages\\local-information\\usa\\air-sea.vue' /* webpackChunkName: "pages/local-information/usa/air-sea" */))
const _4a2bbdba = () => interopDefault(import('..\\pages\\local-information\\usa\\freight.vue' /* webpackChunkName: "pages/local-information/usa/freight" */))
const _1112b10f = () => interopDefault(import('..\\pages\\solution\\automotive-logistics\\_slug.vue' /* webpackChunkName: "pages/solution/automotive-logistics/_slug" */))
const _5809a512 = () => interopDefault(import('..\\pages\\solution\\contract-logistics\\_slug.vue' /* webpackChunkName: "pages/solution/contract-logistics/_slug" */))
const _322e0a97 = () => interopDefault(import('..\\pages\\local-information\\_slug.vue' /* webpackChunkName: "pages/local-information/_slug" */))
const _0fb611a3 = () => interopDefault(import('..\\pages\\post\\_slug.vue' /* webpackChunkName: "pages/post/_slug" */))
const _1d02d2aa = () => interopDefault(import('..\\pages\\solution\\_slug.vue' /* webpackChunkName: "pages/solution/_slug" */))
const _6b5357cb = () => interopDefault(import('..\\pages\\index.vue' /* webpackChunkName: "pages/index" */))

const emptyFn = () => {}

Vue.use(Router)

export const routerOptions = {
  mode: 'history',
  base: '/',
  linkActiveClass: 'nuxt-link-active',
  linkExactActiveClass: 'nuxt-link-exact-active',
  scrollBehavior,

  routes: [{
    path: "/about/",
    component: _36f17688,
    name: "about___en"
  }, {
    path: "/sr/about/",
    component: _36f17688,
    name: "about___sr"
  }, {
    path: "/career/",
    component: _7bca490d,
    name: "career___en"
  }, {
    path: "/sr/career/",
    component: _7bca490d,
    name: "career___sr"
  }, {
    path: "/contact/",
    component: _55a5b04e,
    name: "contact___en"
  }, {
    path: "/sr/contact/",
    component: _55a5b04e,
    name: "contact___sr"
  }, {
    path: "/gallery/",
    component: _52a1920b,
    name: "gallery___en"
  }, {
    path: "/sr/gallery/",
    component: _52a1920b,
    name: "gallery___sr"
  }, {
    path: "/global-presence/",
    component: _7fa46c1e,
    name: "global-presence___en"
  }, {
    path: "/sr/global-presence/",
    component: _7fa46c1e,
    name: "global-presence___sr"
  }, {
    path: "/local-information/",
    component: _33e4abdf,
    name: "local-information___en"
  }, {
    path: "/sr/local-information/",
    component: _33e4abdf,
    name: "local-information___sr"
  }, {
    path: "/news/",
    component: _89a0932c,
    name: "news___en"
  }, {
    path: "/sr/news/",
    component: _89a0932c,
    name: "news___sr"
  }, {
    path: "/privacy-policy/",
    component: _ca9c0c24,
    name: "privacy-policy___en"
  }, {
    path: "/sr/privacy-policy/",
    component: _ca9c0c24,
    name: "privacy-policy___sr"
  }, {
    path: "/solutions/",
    component: _7409d6da,
    name: "solutions___en"
  }, {
    path: "/sr/solutions/",
    component: _7409d6da,
    name: "solutions___sr"
  }, {
    path: "/tempvideo/",
    component: _773a5762,
    name: "tempvideo___en"
  }, {
    path: "/sr/tempvideo/",
    component: _773a5762,
    name: "tempvideo___sr"
  }, {
    path: "/tracking/",
    component: _16a260ce,
    name: "tracking___en"
  }, {
    path: "/sr/tracking/",
    component: _16a260ce,
    name: "tracking___sr"
  }, {
    path: "/about/certificates/",
    component: _d397387c,
    name: "about-certificates___en"
  }, {
    path: "/sr/about/certificates/",
    component: _d397387c,
    name: "about-certificates___sr"
  }, {
    path: "/about/history/",
    component: _38b5fa04,
    name: "about-history___en"
  }, {
    path: "/sr/about/history/",
    component: _38b5fa04,
    name: "about-history___sr"
  }, {
    path: "/about/numbers/",
    component: _08a03c98,
    name: "about-numbers___en"
  }, {
    path: "/sr/about/numbers/",
    component: _08a03c98,
    name: "about-numbers___sr"
  }, {
    path: "/about/terms/",
    component: _e2f5fa1e,
    name: "about-terms___en"
  }, {
    path: "/sr/about/terms/",
    component: _e2f5fa1e,
    name: "about-terms___sr"
  }, {
    path: "/career/application/",
    component: _444489d7,
    name: "career-application___en"
  }, {
    path: "/sr/career/application/",
    component: _444489d7,
    name: "career-application___sr"
  }, {
    path: "/career/programletnjeprakse/",
    component: _542d34f7,
    name: "career-programletnjeprakse___en"
  }, {
    path: "/sr/career/programletnjeprakse/",
    component: _542d34f7,
    name: "career-programletnjeprakse___sr"
  }, {
    path: "/solution/automotive-logistics/",
    component: _12c95257,
    name: "solution-automotive-logistics___en"
  }, {
    path: "/sr/solution/automotive-logistics/",
    component: _12c95257,
    name: "solution-automotive-logistics___sr"
  }, {
    path: "/solution/contract-logistics/",
    component: _59c0465a,
    name: "solution-contract-logistics___en"
  }, {
    path: "/sr/solution/contract-logistics/",
    component: _59c0465a,
    name: "solution-contract-logistics___sr"
  }, {
    path: "/career/programletnjeprakse/galerija/",
    component: _54919e96,
    name: "career-programletnjeprakse-galerija___en"
  }, {
    path: "/sr/career/programletnjeprakse/galerija/",
    component: _54919e96,
    name: "career-programletnjeprakse-galerija___sr"
  }, {
    path: "/career/programletnjeprakse/iskustvakolega/",
    component: _7b7c48c0,
    name: "career-programletnjeprakse-iskustvakolega___en"
  }, {
    path: "/sr/career/programletnjeprakse/iskustvakolega/",
    component: _7b7c48c0,
    name: "career-programletnjeprakse-iskustvakolega___sr"
  }, {
    path: "/career/programletnjeprakse/praksainformacije/",
    component: _2e723cde,
    name: "career-programletnjeprakse-praksainformacije___en"
  }, {
    path: "/sr/career/programletnjeprakse/praksainformacije/",
    component: _2e723cde,
    name: "career-programletnjeprakse-praksainformacije___sr"
  }, {
    path: "/career/programletnjeprakse/stipendiranjestudenata/",
    component: _6a5257e6,
    name: "career-programletnjeprakse-stipendiranjestudenata___en"
  }, {
    path: "/sr/career/programletnjeprakse/stipendiranjestudenata/",
    component: _6a5257e6,
    name: "career-programletnjeprakse-stipendiranjestudenata___sr"
  }, {
    path: "/career/programletnjeprakse/usloviucesca/",
    component: _111d40c9,
    name: "career-programletnjeprakse-usloviucesca___en"
  }, {
    path: "/sr/career/programletnjeprakse/usloviucesca/",
    component: _111d40c9,
    name: "career-programletnjeprakse-usloviucesca___sr"
  }, {
    path: "/career/programletnjeprakse/viseoprogramu/",
    component: _212c50a2,
    name: "career-programletnjeprakse-viseoprogramu___en"
  }, {
    path: "/sr/career/programletnjeprakse/viseoprogramu/",
    component: _212c50a2,
    name: "career-programletnjeprakse-viseoprogramu___sr"
  }, {
    path: "/local-information/albania/m-one-i/",
    component: _3179d849,
    name: "local-information-albania-m-one-i___en"
  }, {
    path: "/sr/local-information/albania/m-one-i/",
    component: _3179d849,
    name: "local-information-albania-m-one-i___sr"
  }, {
    path: "/local-information/bosnia/m-one/",
    component: _0d1c21da,
    name: "local-information-bosnia-m-one___en"
  }, {
    path: "/sr/local-information/bosnia/m-one/",
    component: _0d1c21da,
    name: "local-information-bosnia-m-one___sr"
  }, {
    path: "/local-information/bosnia/m-one-i/",
    component: _6226742f,
    name: "local-information-bosnia-m-one-i___en"
  }, {
    path: "/sr/local-information/bosnia/m-one-i/",
    component: _6226742f,
    name: "local-information-bosnia-m-one-i___sr"
  }, {
    path: "/local-information/bosnia/warehouse-lukavica-sarajevo/",
    component: _2748a131,
    name: "local-information-bosnia-warehouse-lukavica-sarajevo___en"
  }, {
    path: "/sr/local-information/bosnia/warehouse-lukavica-sarajevo/",
    component: _2748a131,
    name: "local-information-bosnia-warehouse-lukavica-sarajevo___sr"
  }, {
    path: "/local-information/croatia/warehouse-bobovica/",
    component: _585fa4b5,
    name: "local-information-croatia-warehouse-bobovica___en"
  }, {
    path: "/sr/local-information/croatia/warehouse-bobovica/",
    component: _585fa4b5,
    name: "local-information-croatia-warehouse-bobovica___sr"
  }, {
    path: "/local-information/macedonia/m-one-i/",
    component: _1089e440,
    name: "local-information-macedonia-m-one-i___en"
  }, {
    path: "/sr/local-information/macedonia/m-one-i/",
    component: _1089e440,
    name: "local-information-macedonia-m-one-i___sr"
  }, {
    path: "/local-information/montenegro/m-one-i/",
    component: _6e7b2282,
    name: "local-information-montenegro-m-one-i___en"
  }, {
    path: "/sr/local-information/montenegro/m-one-i/",
    component: _6e7b2282,
    name: "local-information-montenegro-m-one-i___sr"
  }, {
    path: "/local-information/slovenia/logatec-warehouse/",
    component: _2d1301ab,
    name: "local-information-slovenia-logatec-warehouse___en"
  }, {
    path: "/sr/local-information/slovenia/logatec-warehouse/",
    component: _2d1301ab,
    name: "local-information-slovenia-logatec-warehouse___sr"
  }, {
    path: "/local-information/usa/air-sea/",
    component: _019d72a8,
    name: "local-information-usa-air-sea___en"
  }, {
    path: "/sr/local-information/usa/air-sea/",
    component: _019d72a8,
    name: "local-information-usa-air-sea___sr"
  }, {
    path: "/local-information/usa/freight/",
    component: _4a2bbdba,
    name: "local-information-usa-freight___en"
  }, {
    path: "/sr/local-information/usa/freight/",
    component: _4a2bbdba,
    name: "local-information-usa-freight___sr"
  }, {
    path: "/solution/automotive-logistics/:slug?/",
    component: _1112b10f,
    name: "solution-automotive-logistics-slug___en"
  }, {
    path: "/sr/solution/automotive-logistics/:slug?/",
    component: _1112b10f,
    name: "solution-automotive-logistics-slug___sr"
  }, {
    path: "/solution/contract-logistics/:slug?/",
    component: _5809a512,
    name: "solution-contract-logistics-slug___en"
  }, {
    path: "/sr/solution/contract-logistics/:slug?/",
    component: _5809a512,
    name: "solution-contract-logistics-slug___sr"
  }, {
    path: "/local-information/:slug?/",
    component: _322e0a97,
    name: "local-information-slug___en"
  }, {
    path: "/sr/local-information/:slug?/",
    component: _322e0a97,
    name: "local-information-slug___sr"
  }, {
    path: "/post/:slug?/",
    component: _0fb611a3,
    name: "post-slug___en"
  }, {
    path: "/sr/post/:slug?/",
    component: _0fb611a3,
    name: "post-slug___sr"
  }, {
    path: "/solution/:slug?/",
    component: _1d02d2aa,
    name: "solution-slug___en"
  }, {
    path: "/sr/solution/:slug?/",
    component: _1d02d2aa,
    name: "solution-slug___sr"
  }, {
    path: "/",
    component: _6b5357cb,
    name: "index___en"
  }, {
    path: "/sr/",
    component: _6b5357cb,
    name: "index___sr"
  }],

  fallback: false
}

export function createRouter (ssrContext, config) {
  const base = (config._app && config._app.basePath) || routerOptions.base
  const router = new Router({ ...routerOptions, base  })

  // TODO: remove in Nuxt 3
  const originalPush = router.push
  router.push = function push (location, onComplete = emptyFn, onAbort) {
    return originalPush.call(this, location, onComplete, onAbort)
  }

  const resolve = router.resolve.bind(router)
  router.resolve = (to, current, append) => {
    if (typeof to === 'string') {
      to = normalizeURL(to)
    }
    return resolve(to, current, append)
  }

  return router
}
